import Vue from 'vue'

export default {
  setOwnedPlaces: (state, value) => {
    state.ownedPlaces = value
  },
  setPlaces: (state, value) => {
    state.places = value
  },
  setPlace: (state, value) => {
    state.place = value
  },
  setTotalSpots: (state, value) => {
    state.totalSpots = value
  },
  setAvailableSpots: (state, value) => {
    state.availableSpots = value
  },
  setSessions: (state, value) => {
    state.sessions = value
  },
  addSession: (state, value) => {
    const exists = state.sessions.some(sess => {
      return sess.Id === value.Id
    })
    if (!exists) {
      state.sessions.push(value)
    }
  },
  setSessionInSessionsArray: (state, payload) => {
    const existingSession = state.sessions.find(
      session => session.Id === payload.Id
    )
    Object.assign(existingSession, payload)
  },
  setControllers: (state, value) => {
    state.controllers = value
  },
  setControllerInControllerArray: (state, payload) => {
    const existingController = state.controllers.find(
      controller => controller.id === payload.id
    )
    Object.assign(existingController, payload)

    // const editedItemIndex = state.controllers.findIndex(editedItem => {
    //   return editedItem.Id == item.data.Id
    // })
    // const existingGgates = $scope.gateControllers[editedItemIndex].Gates
    // Object.assign($scope.gateControllers[editedItemIndex], item.data)
  },
  setGateIsAlwaysOpened: (state, payload) => {
    const existingController = state.controllers.find(
      controller => controller.Id === payload.controllerId
    )
    if (existingController.Gates[payload.gateIndex]) {
      Vue.set(
        existingController.Gates[payload.gateIndex],
        'isAlwaysOpened',
        payload.isAlwaysOpened
      )
    }
  },
  setControllerLogs: (state, value) => {
    state.controllerLogs = value
  },
  setSelectedController: (state, value) => {
    state.selectedController = value
  },
  setOpeningOrClosingGate: (state, value) => {
    state.openingOrClosingGate = value
  },
  setLoadingControllers: (state, value) => {
    state.loadingControllers = value
  },
  setRefreshingControllers: (state, value) => {
    state.refreshingControllers = value
  },
  setControllerFirmwareList: (state, value) => {
    state.controllerFirmwareList = value
  },
  /**
   * Sets specified key value on place Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setPlaceValue: (state, data) => {
    Vue.set(state.place, data.key, data.value)
  },
  /**
   * Sets specified key value on place AvailabilityTable Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setPlaceAvailabilityTableValue: (state, data) => {
    Vue.set(state.place.AvailabilityTable, data.key, data.value)
  },
  /**
   * Sets specified key value on place DiscountPlan Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setPlaceDiscountPlanValue: (state, data) => {
    Vue.set(state.place.DiscountPlan, data.key, data.value)
  }
}
